import React, { useEffect, useState } from "react";
import ExportComponents from "../../../Components/ExportComponents";
import Account from "../../../Services/accountServices";
import USDFigure from "../../../Components/USDFigure";
import { Button } from "primereact/button";
import { NavLink } from "react-router-dom";
import TitleHeader from "../Components/TitleHeader";
import { SelectField } from "../../../Components/InputFormFields";
import { getDates } from "../../../helpers/quick";
function IncomeStatement(props) {
  const [startDate, setStartDate] = useState(
    `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`
  );
  const [endDate, setEndDate] = useState(
    `${new Date().getFullYear()}-${
      new Date().getMonth() + 1
    }-${new Date().getDate()}`
  );
  const quickOptions = [
    { value: "today", label: "Today" },
    { value: "week", label: "Last Week" },
    { value: "month", label: "Last Month" },
    { value: "months-3", label: "Last Three Months" },
    { value: "year", label: "Last Year" },
  ];
  const [incomeStatement, setIncomeStatement] = useState([]);
  const [statement, setStatement] = useState(0);
  const [loading, setLoading] = useState(false);
  const [expandedAccounts, setExpandedAccounts] = useState([]);
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const filter = async () => {
    fetchIncomeStatement();
  };
  const fetchIncomeStatement = async () => {
    setLoading(true);
    let data = {
      startDate: startDate,
      endDate: endDate,
    };
    await Account.getIncomeStatement(data).then((ist) => {
      setIncomeStatement(ist.data);
      const data = ist.data;
      let totalexpense = data.find((op) => op.name === "Expenses")?.balance;
      let totalincome = data.find((op) => op.name === "Income")?.balance;
      setStatement(totalincome - totalexpense);
      setLoading(false);
      //Expand all accounts by default
      if (isAllExpanded) {
        setExpandedAccounts([]);
      } else {
        const allAccountIds = data.map((acc) => acc.id);
        setExpandedAccounts(allAccountIds);
      }
      setIsAllExpanded(true);
      //End Expansion
    });
  };
  useEffect(() => {
    fetchIncomeStatement();
  }, []);
  const handleQuickOption = (value) => {
    const dates = getDates(value);
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
    console.log("____ dates", dates);
  };
  const toggleAllRows = () => {
    if (isAllExpanded) {
      setExpandedAccounts([]);
    } else {
      const allAccountIds = incomeStatement.map((acc) => acc.id);
      setExpandedAccounts(allAccountIds);
    }
    setIsAllExpanded(!isAllExpanded);
    console.log("EXpanded", expandedAccounts);
  };

  const toggleAccount = (accountId) => {
    if (expandedAccounts.includes(accountId)) {
      setExpandedAccounts(expandedAccounts.filter((id) => id !== accountId));
    } else {
      setExpandedAccounts([...expandedAccounts, accountId]);
    }
  };

  const renderAccounts = (accounts, level = 0) => {
    return accounts?.map((acc) => (
      <>
        <tr>
          <td style={{ paddingLeft: level * 20 }}>
            <a key={acc.id} onClick={() => toggleAccount(acc.id)}>
              {acc.accounts?.length > 0 && (
                <i
                  class={
                    expandedAccounts.includes(acc.id)
                      ? "ion-arrow-down-b"
                      : "ion-arrow-right-b"
                  }
                ></i>
              )}
            </a>
            &nbsp;&nbsp;
            {acc.id ? (
              <NavLink to={`/account-quick-report/${acc.id}`}>
                {acc.name}
              </NavLink>
            ) : (
              acc.name
            )}
          </td>
          {acc.balance > 0 ? (
            <p style={{ color: "green" }}>
              <USDFigure amount={acc.balance} />
            </p>
          ) : (
            <p style={{ color: "red" }}>
              <USDFigure amount={acc.balance} />
            </p>
          )}
        </tr>
        {expandedAccounts.includes(acc.id) &&
          acc.accounts?.map((sub) => (
            <>
              <tr>
                <td style={{ paddingLeft: (level + 1) * 20 }}>
                  <a key={sub.id} onClick={() => toggleAccount(sub.id)}>
                    {sub.subAccountArray?.length > 0 && (
                      <i
                        class={
                          expandedAccounts.includes(sub.id)
                            ? "ion-arrow-down-b"
                            : "ion-arrow-right-b"
                        }
                      ></i>
                    )}
                  </a>
                  &nbsp;&nbsp;
                  <NavLink to={`/account-quick-report/${sub.id}`}>
                    {sub.name}
                  </NavLink>
                </td>
                {sub.balanceTotal > 0 ? (
                  <p style={{ color: "green" }}>
                    <USDFigure amount={sub.balanceTotal} />
                  </p>
                ) : (
                  <p style={{ color: "red" }}>
                    <USDFigure amount={sub.balanceTotal} />
                  </p>
                )}
              </tr>
              {sub.subAccountArray &&
                renderAccounts(sub.subAccountArray, level + 3)}
            </>
          ))}
      </>
    ));
  };

  return (
    <div class="page-wrapper">
      <div class="content container-fluid">
        <TitleHeader title="Income Statement" />

        <div class="row">
          <div class="col-sm-12">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <div>
                  Start Date
                  <input
                    className="form-control "
                    type="date"
                    value={startDate}
                    name="start_date"
                    onChange={(val) => setStartDate(val.target.value)}
                  />
                </div>
                <div>
                  End Date
                  <input
                    className="form-control "
                    type="date"
                    value={endDate}
                    name="end_date"
                    onChange={(val) => setEndDate(val.target.value)}
                  />
                </div>

                <div>
                  <br />
                  <a href="#" className="btn btn-secondary" onClick={filter}>
                    <i class="ion-ios7-search-strong"></i> Search
                  </a>
                </div>
              </div>

              <p>
                <br />
                Profit/Loss ={" "}
                {statement > 0 ? (
                  <span class="badge badge-pill badge-success">
                    <USDFigure amount={statement} />
                  </span>
                ) : (
                  <span class="badge badge-pill badge-danger">
                    <USDFigure amount={statement} />
                  </span>
                )}
              </p>
              <ExportComponents
                excelData={incomeStatement}
                fileName={endDate + "IncomeStatement.xlsx"}
              />
            </div>
            <div>
              <SelectField
                label="Quick Option"
                name="quickOption"
                options={quickOptions}
                onChange={(value) => handleQuickOption(value.value)}
                searchable={true}
              />
            </div>
            <Button
              icon="pi pi-plus"
              label={isAllExpanded ? "Collapse All" : "Expand All"}
              onClick={toggleAllRows}
              text
            />
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Account</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>{renderAccounts(incomeStatement)}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncomeStatement;
